var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize.debounce",value:(_vm.onResize),expression:"onResize",modifiers:{"debounce":true}}],staticClass:"viewport perspective"},[_c('slider',{attrs:{"update-slider-pos":_vm.updateSliderPos,"override-pos":_vm.sliderOverridePos}}),_vm._t("default"),_c('canvas',{staticClass:"layer3D"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }